export const LAYOUT_SIMPLE = 'simple';
